import { useConfig as hook } from '@eika-infrastruktur/config-provider';
import { nbTranslations, nnTranslations } from './translations';
export const defaultConfig = {
    links: {},
    siteLang: 'nb',
    translations: {
        nb: nbTranslations,
        nn: nnTranslations,
    },
    featureToggles: {
        enableInsurance: false,
        enableDamageInsurance: false,
        enableLoan: false,
        enableCreditLoan: false,
        enableHoldings: false,
        enableStudentLoan: false,
        enableKredittbankenLoans: false,
        enableLockedInsuranceList: false,
        enableTotalSavings: false,
    },
    maxVisibleElements: 3,
};
function createHook() {
    return () => hook();
}
export const useConfig = createHook();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmYXVsdC1jb25maWcuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvZGVmYXVsdC1jb25maWcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFNBQVMsSUFBSSxJQUFJLEVBQWMsTUFBTSxxQ0FBcUMsQ0FBQztBQUVwRixPQUFPLEVBQTBCLGNBQWMsRUFBRSxjQUFjLEVBQUUsTUFBTSxnQkFBZ0IsQ0FBQztBQThDeEYsTUFBTSxDQUFDLE1BQU0sYUFBYSxHQUFXO0lBQ2pDLEtBQUssRUFBRSxFQUFFO0lBQ1QsUUFBUSxFQUFFLElBQWE7SUFDdkIsWUFBWSxFQUFFO1FBQ1YsRUFBRSxFQUFFLGNBQWM7UUFDbEIsRUFBRSxFQUFFLGNBQWM7S0FDckI7SUFDRCxjQUFjLEVBQUU7UUFDWixlQUFlLEVBQUUsS0FBSztRQUN0QixxQkFBcUIsRUFBRSxLQUFLO1FBQzVCLFVBQVUsRUFBRSxLQUFLO1FBQ2pCLGdCQUFnQixFQUFFLEtBQUs7UUFDdkIsY0FBYyxFQUFFLEtBQUs7UUFDckIsaUJBQWlCLEVBQUUsS0FBSztRQUN4Qix3QkFBd0IsRUFBRSxLQUFLO1FBQy9CLHlCQUF5QixFQUFFLEtBQUs7UUFDaEMsa0JBQWtCLEVBQUUsS0FBSztLQUM1QjtJQUNELGtCQUFrQixFQUFFLENBQUM7Q0FDeEIsQ0FBQztBQUVGLFNBQVMsVUFBVTtJQUNmLE9BQU8sR0FBRyxFQUFFLENBQUMsSUFBSSxFQUFLLENBQUM7QUFDM0IsQ0FBQztBQUVELE1BQU0sQ0FBQyxNQUFNLFNBQVMsR0FBRyxVQUFVLEVBQXdCLENBQUMifQ==